import { Component, Input, OnInit } from '@angular/core';
import { DossierService } from '../../../services/dossier.service';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.css'
})
export class PreviewComponent implements OnInit {
  @Input()
  record:any;

  constructor(private dossierService: DossierService){}
  ngOnInit(): void {
    this.dossierService.getItem(this.record.id).subscribe((result)=>{
      this.record=result;
      // console.log(this.record);
    })
    
  }

  calculateFormula(formula,fields){
    
    // sostituisci nella formula i valori degli altri campi
    for(let f of fields){
      formula=formula.replaceAll("{{"+f.name+"}}",f.value);
    }
    const result=eval(formula);
    return result;   

  }
  

  checkEnableCondition(fields,enable_condition_fieldname){
    
    if(enable_condition_fieldname){
      for(let f of fields){
        if(f.name==enable_condition_fieldname){
          if(f.value=='' || f.value==0 || f.value==undefined || f.value==null){
            return false;
          }
    
        }
      }
    }

    return true;
  }
  

  close(){
    this['modalWindow'].close();
  }

}
